import React from 'react';
import { clsx } from 'clsx';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'dark' | 'darker' | 'accent';
}
export function Section({
  children,
  className,
  id,
  background = 'dark'
}: SectionProps) {
  const backgrounds = {
    dark: 'bg-slate-900',
    darker: 'bg-slate-950',
    accent: 'bg-slate-800'
  };
  return <section id={id} className={clsx('py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden', backgrounds[background], className)} data-id="element-300">
      <div className="max-w-7xl mx-auto w-full relative z-10" data-id="element-301">{children}</div>
    </section>;
}